import { render, staticRenderFns } from "./SendEmailPopup.vue?vue&type=template&id=584f3122"
import script from "./SendEmailPopup.vue?vue&type=script&lang=js"
export * from "./SendEmailPopup.vue?vue&type=script&lang=js"
import style0 from "./SendEmailPopup.vue?vue&type=style&index=0&id=584f3122&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports